import styled from "styled-components";

export const LoadingInnerWrapper = styled.div`
    height: 55px;
    margin: 25px;
`;